<template><div><h1 id="versandkosten-berechnung" tabindex="-1"><a class="header-anchor" href="#versandkosten-berechnung"><span>Versandkosten-Berechnung</span></a></h1>
<p>Portoberechnung — Portoberechnung für Web-Anwendungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden die Parameter für die Versandkosten-Berechnung eingetragen. Abhängig von diversen Attributen wie Personenmerkmal, Auftragsart usw. können Porti nach Anzahl Artikel oder Gewicht zugeordnet werden.</p>
<p>Das Regelsystem funktioniert so: Für einen gegebenen Auftrag sucht das System nach der ersten Regel, die zum Auftrag passt. Die Regel definiert dabei einen Portoartikel und ein Preisberechnungsmodell. Das gefundene Preismodell kann dann den Preis des Portos berechnen und dabei auf alle Daten des Auftrags zurückgreifen.</p>
<p>Diese Berechnung funktioniert nur mit dem Web-Service CheckOrder für Internetanwendungen!</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Versandkosten-Berechnung (FTML/BEI)</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Positionsnummer</dt>
<dd>Zur expliziten Sortierung des Systems.</dd>
<dt>Auftragsart</dt>
<dd><a class="link" href="ft.refdata.tblaufart.html" title="Auftragsart">Auftragsart</a></dd>
<dt>Personenmerkmal</dt>
<dd><a class="link" href="ft.refdata.tbladrmerkmal.html" title="Personenmerkmal">Personenmerkmal, z.B. zur Selektion von Wiederverkäufern.</a></dd>
<dt>Versandart</dt>
<dd>Versandart</dd>
<dt>Portoartikel</dt>
<dd>Artikelnummer des betreffenden Portoartikels.</dd>
<dt>Preisstaffelung</dt>
<dd>Auswahl eines Preismodells, wie Fixpreis oder Formel mit gewissen Parametern:
<table>
<thead>
<tr>
<th>Modell</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Artikelmenge</td>
<td>Nach Artikelmenge, wobei optional nur die Artikel einer bestimmten Artikelgruppe (siehe oben) berücksichtigt werden.</td>
</tr>
<tr>
<td>Gewicht</td>
<td>Hier werden die Gewichte aller Positionen berechnet und in der Preisstaffelungstabelle den Portopreisen zugeordnet.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Artikelgruppe</dt>
<dd>Nur bei Modell &quot;Artikelmenge&quot;. Nur Artikel dieser Gruppe werden bei der Mengenberechnung berücksichtigt</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.preisstaffelung.html" title="Portoberechnung Positionen">Preisstaffelung</RouteLink></p>
</div></template>


